import React from 'react';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartWrapper } from './OriginalBudgetMainChart.styles';
import { colors } from '@alixpartners/ui-components';
import isEqual from 'lodash/isEqual';

export class OriginalBudgetMainChart extends React.Component {
	chart = null;

	componentDidUpdate(prevProps) {
		const { series } = this.props;

		if (!isEqual(series, prevProps.series)) {
			this.setAxisLimit();
		}
	}

	getChartOptions = () => {
		const { spendFormatter, categories, series, title } = this.props;

		return {
			chart: {
				type: 'column',
				marginTop: 41,
				height: 310,
				style: { fontFamily: 'Roboto' },
				spacingBottom: 40,
				events: {
					redraw: () => {
						this.drawTargets();
					},
				},
			},
			title: {
				text: '',
			},
			exporting: { enabled: false },
			credits: {
				enabled: false,
			},
			xAxis: {
				title: {
					enabled: false,
				},
				lineWidth: 0,
				labels: {
					autoRotation: false,
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey8,
					},
				},
				gridLineWidth: 0,
				categories,
				offset: 10,
			},
			yAxis: {
				title: {
					align: 'high',
					text: title,
					textAlign: 'right',
					rotation: 0,
					y: -30,
					offset: 15,
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey8,
					},
				},
				gridLineWidth: 0,
				lineColor: 'black',
				lineWidth: 1,
				labels: {
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey8,
					},
					formatter: function() {
						return spendFormatter(this.value, true);
					},
				},
				plotLines: [
					{
						color: 'black',
						width: 1,
						value: 0,
					},
				],
			},
			legend: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			plotOptions: {
				column: {
					dataLabels: {
						enabled: true,
						crop: false,
						overflow: 'none',
						inside: false,
						style: {
							fontWeight: '500',
						},
						formatter: function() {
							return spendFormatter(this.y, true);
						},
					},
				},
				series: {
					animation: false,
					borderWidth: 0,
					pointPadding: 0.05,
					states: {
						hover: {
							enabled: false,
						},
					},
				},
			},
			series,
		};
	};

	onChartInit = chart => {
		this.chart = chart;
		this.setAxisLimit();
		this.drawTargets();
	};

	drawTargets = () => {
		if (!this.chart) {
			return;
		}

		const { spendFormatter } = this.props;
		const { series, renderer, xAxis, yAxis } = this.chart;
		const data = series[0].data;

		if (this.chart.customTarget) {
			this.chart.customTarget.destroy();
			this.chart.customTarget = undefined;
		}

		this.chart.customTarget = renderer
			.g('customTarget')
			.attr({
				zIndex: 100,
			})
			.add();

		data.forEach(el => {
			const pointOffset = el.pointWidth / 2 - 1;
			const startX = xAxis[0].toPixels(el.x) - pointOffset;
			const offset = 13;
			const labelOffset = 4;
			const endX = startX + pointOffset * 2 + offset;
			const distY = yAxis[0].toPixels(el.target);

			if (el.target != null) {
				renderer
					.path(['M', startX, distY, 'L', endX, distY])
					.attr({
						fill: colors.grey6,
						stroke: colors.grey6,
						'stroke-width': 1,
						'stroke-dasharray': '2 2',
					})
					.add(this.chart.customTarget);
				renderer
					.text(spendFormatter(el.target, true), endX, distY - labelOffset)
					.attr({
						rotation: -90,
					})
					.css({
						color: colors.grey5,
						fontSize: '11px',
						fontFamily: 'Roboto',
						fontWeight: 500,
					})
					.add(this.chart.customTarget);
			}
		});
	};

	setAxisLimit = () => {
		if (!this.chart) {
			return;
		}

		const { yAxis, series } = this.chart;
		const max = yAxis[0].dataMax;
		const min = yAxis[0].dataMin;
		const data = series[0].data;
		const targets = data.map(item => item.target);
		const maxTarget = Math.max.apply(null, targets);
		const minTarget = Math.min.apply(null, targets);

		yAxis[0].setExtremes(
			Math.min(minTarget, min, 0),
			Math.max(maxTarget, max, 0)
		);
	};

	render() {
		return (
			<ChartWrapper>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.getChartOptions()}
					callback={this.onChartInit}
				/>
			</ChartWrapper>
		);
	}
}

export default OriginalBudgetMainChart;
